var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('h1',[_vm._v("Q&A")]),_c('p',[_vm._v("\n    工事中です。質問・不具合等を\n    "),_c('b',[_vm._v("support@honkoku.org")]),_vm._v("までお寄せください！\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }